var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":"","tile":""}},[_c('v-card-text',[_c('v-row',{staticClass:"text-center"},[_c('v-col',{attrs:{"cols":"12"}},[_c('copy-url',{attrs:{"store-id":_vm.storeId}})],1),_c('v-col',{attrs:{"cols":"12"}},[_c('contactless-form',{attrs:{"account-id":_vm.accountId,"store-id":_vm.storeId}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }